
document.addEventListener("DOMContentLoaded", () => {
  let storedPhoneNumber = null;
  const apiKey =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ4aXlqeWRqbHpvemxycnRxaGNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzE2NTYzOTcsImV4cCI6MjA0NzIzMjM5N30.sQBtPgaK9fCk1DdD2xxVqCTnJ6Q17RDdAly7WLZ6zl8";


 const sendOtpButtons = document.querySelectorAll(".sendOTP");
  sendOtpButtons.forEach(button => {
    button.addEventListener("click", async () => {
    // alert("button clicked");
      const mobileFieldContainer = event.target.closest(".loginForm");
      const phoneNumberInput = mobileFieldContainer?.querySelector("input.phone");
      const phoneNumberInputcode = mobileFieldContainer?.querySelector("select#countryCodeselecter").value;
      if (!phoneNumberInput) {
          console.error("Phone number input not found.");
          return;
        }
    
    const phoneNumber = phoneNumberInput.value.trim();
     // alert(phoneNumber + "phoneNumber");
    if (!phoneNumber || phoneNumber.length !== 10 || isNaN(phoneNumber)) {
      showError(phoneNumberInputs[0], "Please enter a valid 10-digit phone number.");
      return;
    }
    // storedPhoneNumber = `+91${phoneNumber}`;
    storedPhoneNumber = `+${phoneNumberInputcode}${phoneNumber}`;
    const whatsappPermission =
      document.getElementById("whatsappChk").checked;
    const requestBody = {
      phone: storedPhoneNumber,
      data: {
        whatsapp_permission: whatsappPermission,
      },
    };

    try {
      const response = await fetch(
        "https://rxiyjydjlzozlrrtqhci.supabase.co/auth/v1/otp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (response.ok) {
        console.log('ok response received');
          // document.querySelectorAll('.stored_phone').innerHTML = storedPhoneNumber;
        document.querySelectorAll('.stored_phone').forEach(el => {
            el.innerHTML = storedPhoneNumber;
        });
          document.querySelectorAll('.loginForm').forEach(el => el.style.display = "none");
          document.querySelectorAll('.otpContainer').forEach(el => el.style.display = "flex");
         // document.querySelector('.mobilenum_btn_sticky').style.display = "none";
          // document.querySelectorAll('.mobileVal').forEach(el => el.style.display = "block");

          // const botLinks = document.querySelectorAll(".inputData");
          // console.log(botLinks);
          // botLinks.forEach( link => {
          //   const baseHref = link.getAttribute("href");
          //   const updatedHref = `${baseHref}?phone_number=${encodeURIComponent(storedPhoneNumber)}`;
          //   link.href = updatedHref;
          //   console.log("Updated botLink href:", updatedHref);
          // });
      } else {
        // alert("Failed to send OTP.");
        const errorDetails = await response.json();
        console.log('failure');
        // showError(phoneNumberInput, "Failed to send OTP. " + (errorDetails.message || ""));
      }
    } catch (error) {
      showError(phoneNumberInput, "An error occurred while sending OTP.");
      console.error(error);
    }
  });
 }); 
  
function showError(inputElement, message) {
  const errorElement = inputElement.closest(".loginForm ").querySelector(".feilds-error");
  if (errorElement) {
    errorElement.textContent = message;
    errorElement.style.display = "block";
    setTimeout(() => {
      errorElement.style.display = "none";
    }, 7000);
  } else {
    console.error("Error element not found near the input field.");
  }
}

function showOtpError(message) {
  const errorElements = document.querySelectorAll(".feilds-error");

  if (errorElements.length > 0) {
    errorElements.forEach((errorElement) => {
      errorElement.textContent = message;
      errorElement.style.display = "block";
    });

    setTimeout(() => {
      errorElements.forEach((errorElement) => {
        errorElement.style.display = "none";
      });
    }, 7000);
  } else {
    console.error("No error elements found.");
  }
}


  const verifyOtpButton = document.querySelectorAll(".verifyOTP");
  verifyOtpButton.forEach(button => {
    button.addEventListener("click", async () => {
    // alert("button clicked");

    const otpInputs = document.querySelectorAll(".otp-box");
    let otp = "";

    otpInputs.forEach((input) => {
      otp += input.value.trim();
    });

    if (otp.length !== 6 || isNaN(otp)) {
      // alert("Please enter a valid 6-digit OTP.");
      showOtpError("Please enter a valid 6-Digit OTP");
      return;
    }

    const requestBody = {
      phone: storedPhoneNumber,
      type: "sms",
      token: otp,
    };

    try {
      const response = await fetch(
        "https://rxiyjydjlzozlrrtqhci.supabase.co/auth/v1/verify",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (response.ok) {
        // alert("Your number has been verified.");
        document.querySelectorAll('.otpContainer').forEach(el => el.style.display = "none");
        document.querySelectorAll('.successContainer').forEach(el => el.style.display = "flex");
        // document.querySelectorAll('.mobileVal').forEach(el => el.style.display = "block");
       document.getElementById("btmP").innerHTML = "For more information reach out to <a href='mailto:venkat@mywonder.in'>venkat@mywonder.in</a> or <a href='tel:9008404341'>+91 9008404341</a>";
      }
      else {
        // alert("Failed to send OTP.");
        console.log('incorrect');
        showOtpError("Entered OTP is incorrect");
      }
    } catch (error) {
      // alert("An error occurred while sending OTP.");
      console.error(error);
    }
  });
     });
});
